// Cursor toggle — small button that swaps between the custom katana
// cursor and the native OS cursor. Sits in the Navbar next to the
// audio control. Persists state via lib/cursorPref.js.

import { useEffect, useState } from "react";
import { MousePointer2, Swords } from "lucide-react";
import { getCursorPref, toggleCursorPref, subscribeCursorPref } from "@/lib/cursorPref";
import { playSfx } from "@/lib/audio";

export default function CursorToggle() {
  const [pref, setPref] = useState(getCursorPref());

  useEffect(() => subscribeCursorPref(setPref), []);

  const isKatana = pref === "katana";
  const Icon = isKatana ? Swords : MousePointer2;
  const color = isKatana ? "#F59E0B" : "rgba(255,255,255,0.45)";

  const onClick = () => {
    toggleCursorPref();
    try { playSfx?.("click"); } catch { /* ignore */ }
  };

  return (
    <button
      type="button"
      data-testid="cursor-toggle-btn"
      onClick={onClick}
      aria-label={isKatana ? "Usa cursore normale" : "Usa cursore katana"}
      title={isKatana ? "Cursore: Katana ⚔️ — clicca per tornare al cursore normale" : "Cursore: Normale — clicca per attivare la Katana"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 28,
        height: 28,
        background: isKatana ? "rgba(245,158,11,0.10)" : "var(--bc-panel-elev, rgba(255,255,255,0.03))",
        border: `1px solid ${isKatana ? "rgba(245,158,11,0.45)" : "var(--bc-border, rgba(255,255,255,0.07))"}`,
        color,
        cursor: "pointer",
        transition: "all 0.15s",
        boxShadow: isKatana ? "0 0 10px -4px #F59E0B" : "none",
      }}
    >
      <Icon size={13} />
    </button>
  );
}
